import { render, staticRenderFns } from "./AnswerUserManager.vue?vue&type=template&id=1c4dd46f&scoped=true"
import script from "./AnswerUserManager.vue?vue&type=script&lang=js"
export * from "./AnswerUserManager.vue?vue&type=script&lang=js"
import style0 from "./AnswerUserManager.vue?vue&type=style&index=0&id=1c4dd46f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4dd46f",
  null
  
)

export default component.exports